import { create } from "zustand";

import {
  InitializePaginationProperties,
  InitializeSetPaginationProperties,
  PaginationProperties,
  SetPaginationProperties
} from "../../../../../common/utils/pagination_property";

/**
 * useControleRecebimentoEpiListaPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useControleRecebimentoEpiListaPagination = create<State & Actions>((set, get) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));